import { render, staticRenderFns } from "./PersonalStats.vue?vue&type=template&id=60639330&"
import script from "./PersonalStats.vue?vue&type=script&lang=js&"
export * from "./PersonalStats.vue?vue&type=script&lang=js&"
import style0 from "./PersonalStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports